import { useNavigate } from "react-router-dom";
import "./company-other-info.scss";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import {
  companyRegistrationSelector,
  registerCompanyInfo,
} from "../../../redux/reducers/company-registration/companyRegistrationSlice";
import { toast } from "react-toastify";
import { SignupContext } from "../../providers/signupProvider";
import { IKeyValuePairOption } from "../../models/interfaces";
import Form from "react-bootstrap/Form";

const CompanyOtherInfo: React.FC = () => {
  const selectCompnayInfo = useAppSelector(companyRegistrationSelector);
  const dispatch = useAppDispatch();
  const { setCurrentStep } = useContext(SignupContext);

  const [mission, setMission] = useState<string>("");
  const [vision, setVision] = useState<string|undefined>("");
  const [challenges, setChallenges] = useState<string | undefined>("");
  const [businessChallengeDescription, setBusinessChallengeDescription] = useState<string | undefined>("");


  useEffect(() => {
    console.log(
      "Company registration information after filling company name and website url",
      selectCompnayInfo
    );

    setVision(selectCompnayInfo.vision);
    setMission(selectCompnayInfo.mission);
    setChallenges(selectCompnayInfo.challenges);
    setBusinessChallengeDescription(selectCompnayInfo.businessChallengeDescription);


  }, [selectCompnayInfo]);

  const navigate = useNavigate();

  const GoToNextStage = (stage: string) => {
    if (vision) {
      setCurrentStep(stage);
      dispatch(
        registerCompanyInfo({
          ...selectCompnayInfo,
          mission: mission,
          vision: vision,
          challenges: challenges,
          businessChallengeDescription: businessChallengeDescription,
        })
      );
      navigate("/signup-s4");
    } else {
      toast(
        "Please fill your company's vision and mission to proceed further."
      );
    }
  };

  const FORM_FIELDS = {
    BUSINESS_CHALLENGES: "BusinessChallenges",
    BUSINESS_CHALLENGE_DESCRIPTION:"BusinessChallengeDescription",
    VISION: "Vision",
  };

  const businessChallengesOptions: IKeyValuePairOption[] = [
    { key: 1, value: "Finding and retaining customers" },
    { key: 2, value: "Competing with other businesses" },
    { key: 3, value: "Managing supply chain issues" },
    { key: 4, value: "Navigating regulations" },
    { key: 5, value: "Implementing new technology" },
    { key: 6, value: "Accessing reliable market data" },
    { key: 7, value: "Other (Please specify)" },
  ];

  const onFormOptionSelectionChanged = (
    selectedOption: IKeyValuePairOption,
    optionType: string
  ) => {
    switch (optionType) {
      case FORM_FIELDS.BUSINESS_CHALLENGES:
        setChallenges(selectedOption.value);
        break;
      
    }
  };

  const onTextValueChanged = (
    value: string | undefined,
    optionType: string
  ) => {
    switch (optionType) {
      case FORM_FIELDS.BUSINESS_CHALLENGE_DESCRIPTION:
        setBusinessChallengeDescription(value);
        break;
        case FORM_FIELDS.VISION:
        setVision(value);
        break;
    }
  };


  return (
    <div className="company-other-info-wrapper">
      <div className="company-info-title">Challenges and Vision</div>
      <div>Tell us about your companies challenges and vision</div>

       {/* Business challenges */}
       <div className="company-info-box">
        <div className="question-text">What are the top three challenges your business is currently facing?</div>
        <div className="question-options">
          {businessChallengesOptions.map(
            (val: IKeyValuePairOption, index: number) => {
              return (
                <div
                  key={index}
                  className={`question-option ${
                    val.value == challenges ? " active" : ""
                  }`}
                  onClick={() => {
                    onFormOptionSelectionChanged(
                      val,
                      FORM_FIELDS.BUSINESS_CHALLENGES
                    );
                  }}
                >
                  {val.value}
                </div>
              );
            }
          )}
        </div>
      </div>

      {/* Details of customer types */}
      <div className="company-info-box">
        <div className="question-text">
        What’s the biggest challenge that keeps you up at night? Feel free to share an example or a brief story.
        </div>
        <div className="question-options">
          {
            <Form.Control
              as="textarea"
              value={businessChallengeDescription}
              onChange={(event) => {
                onTextValueChanged(
                  event?.target.value,
                  FORM_FIELDS.BUSINESS_CHALLENGE_DESCRIPTION
                );
              }}
            />
          }
        </div>
      </div>

      {/* Vision */}
      <div className="company-info-box">
        <div className="question-text">
        Fast forward five years… What’s your big dream for your business, and what type of help would you need to achieve it?
        </div>
        <div className="question-options">
          {
            <Form.Control
              as="textarea"
              value={vision}
              onChange={(event) => {
                onTextValueChanged(
                  event?.target.value,
                  FORM_FIELDS.VISION
                );
              }}
            />
          }
        </div>
      </div>

      {/* Vision
      <div className="company-info-form">
        <span>Fast forward five years… What’s your big dream for your business, and what type of help would you need to achieve it?</span>
        <textarea
          placeholder="Vision"
          className="multiline-input"
          value={vision}
          onChange={(e) => setVision(e.target.value)}
        />
      </div> */}

      <div className="wizard-footer">
        <div>Step 3/4</div>
        <div className="wizard-footer__buttons">
          <div
            className="wizard-button"
            onClick={() => {
              setCurrentStep("COMPANY_MORE");
              navigate("/signup-s2");
            }}
          >
            Back
          </div>
          <div
            className="wizard-button primary-button"
            onClick={() => {
              GoToNextStage("COMPANY_DEEP");
            }}
          >
            Next
          </div>
          {/* COMPANY_MORE */}
        </div>
      </div>
    </div>
  );
};

export default CompanyOtherInfo;


// Meterial UI, Boostrap

// ApI integration

// React outer dom

// statemanagement - react

// Last project - E commerce aplication
  // product list, shoping cart, checkout component user authentication components, offers list

// lazy loading - know about lazy function
// Has knowledge in redux , redux middleware, experiance in rdux thunk, know about the workflow
// Typescript - 1 year (2021), dont have core knowledge in typescript details about interface and class difference
// Hooks - good knowledge in hooks
// Lifecylce event - has good knowledge 
// Authentication - jwt token - knowledge in jwt token

// routing - core knowledge


// scss , know aobut extend, mixins
// knowledge about mixins


// Has good knowledge in javascript


